class PromoPrize {
  constructor() {
    this.claimElement = document.querySelector('.claimPercent')
    this.percentElement = document.querySelector('.prize-percentage')
    this.prizeTextElement = document.querySelector('.prize-text')
    this.init()
  }

  init() {
    if (!this.claimElement || !this.percentElement || !this.prizeTextElement) return;

    const sold = Number(this.claimElement.dataset.sold)
    const available = Number(this.claimElement.dataset.available)

    if (available <= 0) return;

    const percent = Math.round((sold / available) * 100)

    // Update progress bar
    this.claimElement.style.setProperty('--progress-width', `${percent}%`)
    this.percentElement.textContent = `${percent}%`

    // 🎯 Determine messaging by stage
    let message = ''

    if (percent >= 100) {
      message = "All gone!"
    } 
    else if (percent >= 70) {
      message = "Almost gone - last chance!"
    } 
    else if (percent >= 40) {
      message = "Selling fast - grab yours now."
    } 
    else {
      message = "Get yours before they're gone."
    }

    this.prizeTextElement.textContent = message
  }
}

const promoPrize = new PromoPrize();

